import { Event } from '@yandex-int/messenger.utils';

import { ScrollControllerPayload, ScrollStateChangedPayload } from './types';

type ScrollHandler = (payload: ScrollControllerPayload) => void;

/**
 * Универсальный класс для управления скроллом элементов
 * Может быть переиспользован для любых списков с анимированным скроллом
 */
export class ScrollController {
    private scrollHandler: ScrollHandler | undefined;
    public onScrollStateChanged = new Event<ScrollStateChangedPayload>();

    public setScrollHandler(handler: ScrollHandler): void {
        this.scrollHandler = handler;
    }

    public removeScrollHandler(): void {
        this.scrollHandler = undefined;
    }

    public executeScroll(payload: ScrollControllerPayload): void {
        this.scrollHandler?.(payload);
    }
}
